var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes ? _vm.classes : 'sm-search-input'},[_c('div',{staticClass:"icon-prepend"},[_c('Search')],1),_c('input',{attrs:{"placeholder":_vm.placeholder ? _vm.placeholder : ''},on:{"input":_vm.onChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }